import React from 'react';
import { Text } from '@react-pdf/renderer';
import GeneralPageLayout from './GeneralPageLayout';
import _ from 'lodash';
import radiusToText from '../utils/radiusToText';

function raceEthnicityTypeToString (raceEthnicity) {
  switch (raceEthnicity) {
    case 'race_asian_pi':
      return 'Asian / Pacific Islander';
    case 'race_black':
      return 'Black';
    case 'ethnicity_hispanic':
      return 'Hispanic';
    case 'race_native_amer':
      return 'Native American';
    case 'race_other':
      return 'Other';
    case 'race_white':
      return 'White';
    default:
      return;
  }
}

const ThemeCover = ({
  primaryBrand,
  themeData,
  topRaceEthnicities,
  radius,
  zipCode,
  uuid,
}): JSX.Element => {
  return (
    <GeneralPageLayout
      sectionTypeText="AI-Informed Theme"
      sectionTitleText={themeData.name}
      textColor={primaryBrand.colors.dark}
      backgroundColor={'#FFF'}
      footerText={uuid}
    >
      <Text>{themeData.public_name}</Text>
      <Text>Races or Ethnicities Included:</Text>
      {
        _.map(topRaceEthnicities, (raceEthnicity, i) => {
          return (
            <Text
              key={i}
              style={{
                fontFamily: 'Courier',
                fontSize: 14,
                lineHeight: 1.12,
              }}
            >
              • {raceEthnicityTypeToString(raceEthnicity)}
            </Text>
          );
        })
      }
      <Text>This list is based on the top 3 reported races or ethnicities within {radiusToText(radius)} of {zipCode}.</Text>
    </GeneralPageLayout>
  );
};

export default ThemeCover;
